<template>
  <div class="origin-chapters">
    <article
      v-for="chapter in chapters"
      :id="chapter.id"
      :key="chapter.id"
      class="origin-chapter"
    >
      <div class="chapter-marker" aria-hidden="true"></div>
      <div class="chapter-content">
        <p class="chapter-label">{{ chapter.label }}</p>
        <h3>{{ chapter.title }}</h3>
        <p class="chapter-lead">{{ chapter.lead }}</p>
        <p
          v-for="paragraph in chapter.paragraphs"
          :key="paragraph"
          class="chapter-copy"
        >
          {{ paragraph }}
        </p>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'HeroOriginChapters',
  props: {
    chapters: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.origin-chapters {
  margin: 0 auto;
  max-width: 940px;
  position: relative;
}

.origin-chapters::before {
  background: linear-gradient(180deg, rgba(150, 220, 255, 0.08), #8bdcff, rgba(150, 220, 255, 0.08));
  content: '';
  height: calc(100% - 72px);
  left: 19px;
  position: absolute;
  top: 36px;
  width: 1px;
}

.origin-chapter {
  display: grid;
  gap: 26px;
  grid-template-columns: 40px minmax(0, 1fr);
  padding: 28px 0;
  position: relative;
}

.chapter-marker {
  background: #08121d;
  border: 2px solid #9ae4ff;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(98, 206, 255, 0.58);
  height: 15px;
  margin: 9px auto 0;
  width: 15px;
}

.chapter-content {
  background: linear-gradient(135deg, rgba(20, 42, 60, 0.72), rgba(8, 13, 20, 0.92));
  border: 1px solid rgba(154, 228, 255, 0.16);
  border-radius: 10px;
  padding: clamp(22px, 4vw, 38px);
}

.chapter-label {
  color: #7fd9ff;
  font-size: 0.76rem;
  font-weight: 900;
  letter-spacing: 0.16em;
  margin: 0 0 8px;
  text-transform: uppercase;
}

.chapter-content h3 {
  color: #fff;
  font-size: clamp(1.75rem, 4vw, 2.45rem);
  letter-spacing: -0.02em;
  margin: 0 0 18px;
}

.chapter-lead {
  color: #e8f7ff;
  font-size: 1.12rem;
  font-weight: 800;
}

.chapter-copy {
  color: #c7d3dc;
  line-height: 1.75;
  margin-bottom: 12px;
}

.chapter-copy:last-child {
  margin-bottom: 0;
}

@media (max-width: 600px) {
  .origin-chapters::before {
    left: 8px;
  }

  .origin-chapter {
    gap: 14px;
    grid-template-columns: 18px minmax(0, 1fr);
  }

  .chapter-marker {
    height: 11px;
    width: 11px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .chapter-marker {
    box-shadow: none;
  }
}
</style>
